export default __webpack_public_path__ + "static/media/portfolio-174.a9f1dcb2.jpg";